export default function Styles (){
  return (
    <style>
      {
        `
        @media screen and  (min-width: 1543px) {
          .fs-res-24 {
            font-size: 24px !important; 
            line-height: 30px !important;
            font-weight: 400 !important;
        
          }
          
            .fs-res-18 {
              font-size: 18px !important;
              line-height: 18px !important;
            font-weight: 400 !important;
        
            }
            .fs-res-24-18 {
              font-size: 18px !important;
              line-height: 27px !important;
            }
         
        }
        
        @media screen and (max-width: 1534px) {
          .fs-res-24 {
            font-size: 22px !important; 
            line-height: 28px !important;
            font-weight: 400 !important;
        
          }
          .fs-res-18 {
            font-size: 16px !important;
            line-height: 16px !important;
            font-weight: 400 !important;
          }
          .fs-res-24-18 {
            font-size: 16px !important;
            line-height: 24px !important;
          }
          
        }
        
        @media screen and (max-width: 500px) and (min-width: 450px) {
        .px-mobile-explore{
          padding-left:13%;
          padding-right: 13%;
        }
          .px-mobile-explore-img{
            height: 324px !important;
          }
        
        }
        
        `
      }
    </style>
  )
}